const PICKUP_OPTIMYZER_FILTERS = {
  assigned: "Assigned",
  unassigned: "Unassigned",
};
const PICKUP_OPTIMYZER_STEPS = [
  "Correct Pickup Information",
  "Review Optymized Solution",
  "Results",
];

const PICKUP_OPTIMYZER_FILTER_NAME = {
  isAssigned: "isAssigned",
  isUnassigned: "isUnassigned",
};

export {
  PICKUP_OPTIMYZER_FILTERS,
  PICKUP_OPTIMYZER_STEPS,
  PICKUP_OPTIMYZER_FILTER_NAME,
};
